import { SettingsCache } from '~/lib/consts/settings-cache';

const GetWeightOptions = (shortList: boolean) => {
  return shortList
    ? [0.75, 1, 2, 5]
    : SettingsCache.profile?.toUpperCase().indexOf('EVRI.SME') > -1
      ? [0.75, 1, 2, 5, 10, 15]
      : [0.75, 1, 2, 5, 10, 15, 20];
};
export default GetWeightOptions;
